export default __webpack_public_path__ + "static/media/Stalker's Fauld of Malice.4c42ef7b.jpg";